/* eslint func-names: 0 */
import {
  CSL_LISTINGS_PROMOTION,
  HOME_PAGE_REDESIGN,
  PRICE_TABLE,
} from './featureFlags';

let instance = null;
let lazyFeatureSwitches = {};

export const enabledFeatures = new Set([
  CSL_LISTINGS_PROMOTION,
  PRICE_TABLE,
  HOME_PAGE_REDESIGN,
]);

export class FeatureSwitchReaderClass {
  constructor(enabled) {
    const defaultFeatureChecker = (featureName) => {
      if (enabled.has(featureName)) {
        return lazyFeatureSwitches[featureName] !== false;
      }
      return lazyFeatureSwitches[featureName] === true;
    };
    let currentFeatureChecker = defaultFeatureChecker;

    this.setFeatureChecker = function (featureChecker) {
      if (typeof featureChecker === 'function') currentFeatureChecker = featureChecker;
    };

    this.resetFeatureChecker = function () {
      currentFeatureChecker = defaultFeatureChecker;
    };

    this.isFeatureOn = function (featureName) {
      return currentFeatureChecker(featureName);
    };
  }
}

export default {
  set: (featureSwitches) => {
    lazyFeatureSwitches = featureSwitches;
  },
  getInstance: () => {
    instance = instance || new FeatureSwitchReaderClass(enabledFeatures);
    return instance;
  },
};
